<template>
  <div class="tab_action tab_bg">
    <div class="backtop">
      <span class="btncenter">音频管理</span>
    </div>
    <div class="tab" style="position: unset; overflow-y: auto">
      <ul>
        <li @click="Tab = 4" :class="{ check: Tab == 3 }">音效</li>
        <li  @click="Tab = 5" :class="{ check: Tab == 1 }">配乐</li>
      </ul>
      <div class="liebiao">
        <div>
          <span @click="checkTab(2)" :class="{ active: sourceTab == 2 }"
            >平台</span
          >
          <span @click="checkTab(1)" :class="{ active: sourceTab == 1 }"
            >个人</span
          >
        </div>
        <div>
          <select v-model="getAudio.materialType" @change="getAudioList()">
            <option
              :label="item.label"
              :value="item.materialType"
              v-for="(item, i) in categroy"
              :key="i + 'shaixuan'"
            ></option>
          </select>
        </div>
      </div>
        <span @click="checkTab(4)" :class="{ check: Tab == 4 }"
          >音效</span
        >
        <span  @click="checkTab(5)" :class="{ check: Tab == 5 }"
          >配乐</span
        >
      </div>
   
  </div>
</template>

<script>
export default {
  data () {
    return {
      Tab: 4, //主tab切换 4：音效 5：配乐
      
      sourceTab: 2,//1：平台素材  2：个人素材
      getAudio: {
        "searchText": "",
        "pageIndex": 0,
        "pageSize": 24,
        "sort": 1,//	排序 1.正序 2.倒序
        "materialType": '4',//4.音效 5.配乐
        "materialSource": 2,//素材来源 0.默认不筛选 1.个人上传 2.平台素材	
      }
    }
  },
  created () {
    this.getAudioList()
  },
  methods: {
    getAudioList () { //获取素材列表
      this.post("/material/findMaterialList", this.getAudio).then((res) => {
        console.log('请求音效接口', res)
      })

    },
    checkTab (flag) {

      this.showPanelUp = false
      this.sourceTab = flag
      this.getAudio.materialSource = flag
      this.getAudioList()

    }
  },
}
</script>

<style lang="scss" scoped>
.liebiao {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  select {
    height: 29px;
    padding: 0 5px;
    color: #666;
    border: 1px solid #dbdbdb;
  }
}
.liebiao span {
  display: inline-block;
  padding: 5px 10px;
  margin: 0 5px;
  background-color: #f7f8fa;
  border-radius: 2px;
  color: #666;
  cursor: pointer;
}
.liebiao .active {
  background-color: #f4acb7;
  color: #fff;
}
</style>